export function getGradients() {
return [
    // 基础线性渐变
    ['linear', 0, 0, 1, 1, [[0, '#ff6b6b'], [0.5, '#4ecdc4'], [1, '#45b7d1']]],
    ['linear', 0, 0, 0, 1, [[0, '#a8e6cf'], [0.5, '#dcedc1'], [1, '#ff63b6']]],
    ['linear', 0, 0, 1, 0, [[0, '#74ebd5'], [1, '#9face6']]],
    
    // 径向渐变
    ['radial', 0.5, 0.5, 0, 0.5, 0.5, 1, [[0, '#ff9a9e'], [1, '#fecfef']]],
    ['radial', 0.7, 0.3, 0, 0.3, 0.7, 1, [[0, '#4facfe'], [1, '#00f2fe']]],
    
    // 霓虹色系 (Neon)
    ['linear', 0, 0, 1, 1, [[0, '#ff0080'], [0.5, '#ff8c00'], [1, '#40e0d0']]],
    ['linear', 1, 0, 0, 1, [[0, '#00ff87'], [0.5, '#60efff'], [1, '#0061ff']]],
    ['radial', 0.5, 0.5, 0, 0.5, 0.5, 1, [[0, '#ff00cc'], [1, '#333399']]],
    
    // 金属质感 (Metallic)
    ['linear', 0, 0, 1, 1, [[0, '#8e9eab'], [0.3, '#eef2f3'], [0.7, '#eef2f3'], [1, '#8eae3b']]],
    ['linear', 0.2, 0.2, 0.8, 0.8, [[0, '#4da0b0'], [0.5, '#d39d38'], [1, '#4da0b0']]],
    
    // 渐变透明度效果
    ['linear', 0, 0, 1, 0, [[0, 'rgba(255,0,150,0.8)'], [0.5, 'rgba(0,204,255,0.9)'], [1, 'rgba(0,255,100,0.7)']]],
    
    // 对角线渐变
    ['linear', 0, 1, 1, 0, [[0, '#ffecd2'], [0.5, '#fcb69f'], [1, '#a1c4fd']]],
    ['linear', 1, 0, 0, 1, [[0, '#667eea'], [1, '#764ba2']]],
    
    // 多色渐变彩虹效果
    ['linear', 0, 0, 1, 0, [
        [0, '#ff0000'], 
        [0.16, '#ff9900'], 
        [0.33, '#ffff00'], 
        [0.5, '#00ff00'], 
        [0.66, '#00ffff'], 
        [0.83, '#0000ff'], 
        [1, '#ff00ff']
    ]],
    
    // 柔和渐变 (Soft Pastels)
    ['linear', 0, 0, 1, 1, [[0, '#d9afd9'], [0.5, '#97d9e1'], [1, '#b5fffc']]],
    ['radial', 0.5, 0.5, 0, 0.5, 0.5, 0.8, [[0, '#fad0c4'], [1, '#ffd1ff']]],
    
    // 深色主题渐变
    ['linear', 0, 0, 1, 1, [[0, '#0c0c0c'], [0.3, '#2d3436'], [1, '#636e72']]],
    ['radial', 0.5, 0.5, 0, 0.5, 0.5, 1, [[0, '#485563'], [1, '#29323c']]],
    
    // 特殊效果渐变
    ['linear', 0.3, 0.3, 0.7, 0.7, [[0, '#fa709a'], [1, '#fee140']]], // 粉金渐变
    ['linear', 0, 0.5, 1, 0.5, [[0, '#43e97b'], [0.5, '#38f9d7'], [1, '#43e97b']]], // 对称渐变
];
}
